"use client";

import { useEffect, useState } from "react";

/**
 * Custom hook to check if user has answered at least one question in the onboarding
 * Returns true if user has answered at least one question
 */
export const useUserProgress = () => {
  const [hasAnsweredQuestions, setHasAnsweredQuestions] = useState(false);

  useEffect(() => {
    // Start with false state - button won't show until user answers first question
    setHasAnsweredQuestions(false);

    // Check if user has answered questions (stored when first answer is given)
    const checkAnswerStatus = () => {
      try {
        const hasAnswered = sessionStorage.getItem(
          "hasAnsweredOnboardingQuestions",
        );

        setHasAnsweredQuestions(!!hasAnswered);
      } catch {
        // Storage not available
        setHasAnsweredQuestions(false);
      }
    };

    // Set up a listener for storage changes (in case of multiple tabs)
    const handleStorageChange = () => {
      checkAnswerStatus();
    };

    window.addEventListener("storage", handleStorageChange);

    // Check periodically for sessionStorage changes
    const interval = setInterval(checkAnswerStatus, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return hasAnsweredQuestions;
};
